module.exports = __webpack_public_path__ + "img/1479723447.566ebbac.jpg";